// Copyright 2025, University of Maryland, All Rights Reserved
import { useQuery } from '@tanstack/react-query'
import { createJobsApi, JobContext } from '../services/jobs-api'
import { useApi } from '../JobsComponent'

// Create singleton jobs API per component instance
const jobsApiCache = new WeakMap<object, ReturnType<typeof createJobsApi>>();

export const useMonthlyStats = (
  month: string,
  org_id?: string,
  ws_id?: string
) => {
  const { apiInstance } = useApi();

  // Create cached API instance per apiInstance
  if (!jobsApiCache.has(apiInstance)) {
    jobsApiCache.set(apiInstance, createJobsApi(apiInstance));
  }
  const jobsApi = jobsApiCache.get(apiInstance)!;

  return useQuery({
    queryKey: ['jobStats', month, org_id, ws_id],
    queryFn: () => jobsApi.getMonthlyStatsByContext({ org_id, ws_id }, month)
  })
}

export const useRecentJobs = (
  org_id?: string,
  ws_id?: string,
  month?: string
) => {
  const { apiInstance } = useApi();

  // Create cached API instance per apiInstance
  if (!jobsApiCache.has(apiInstance)) {
    jobsApiCache.set(apiInstance, createJobsApi(apiInstance));
  }
  const jobsApi = jobsApiCache.get(apiInstance)!;
  const context: JobContext = { org_id, ws_id }

  return useQuery({
    queryKey: ['recentJobs', org_id, ws_id, month],
    queryFn: () => jobsApi.getRecentJobsByContext(context, 500, month),
    refetchInterval: 30000
  })
}